import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { autodeskLoad } from 'portal/store/integrations/autodesk/actions'

export const useAutodeskLoader = () => {
  const dispatch = useDispatch()

  const reload = useCallback(() => {
    dispatch(autodeskLoad())
  }, [dispatch])

  useEffect(() => {
    reload()
  }, [reload])

  const { loading, error, data } = useSelector((state: any) => {
    return state.integrationAutodesk
  })

  return {
    loading,
    error,
    data,
    reload
  }
}
